// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { observable } from 'mobx';

// models
import { Quicklink } from 'models';

// data
import { preConfiguredQuicklinks } from '../data/pre-configured-quicklinks';

export class QuicklinkStore extends Store {
  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  @observable
  public quicklinks: Quicklink[];

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public fetch(programName: string = '') {
    return fetchByProgramName(programName).then((data) => {
      this.quicklinks = data;
    });
  }
}

const fetchByProgramName = async (programName: string) => {
  switch (programName) {
    case 'uk-vrbo':
      return preConfiguredQuicklinks.vrboUK;

    default:
      return preConfiguredQuicklinks.vrboUS;
  }
};
